<svg:path [attr.fill]="color" [attr.d]="path" />
<svg:text text-anchor="middle" dominant-baseline="central" [attr.x]="textLeft" [attr.y]="height / 2">{{label}}</svg:text>
